import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/ManageHotel/View/hotel-list.html";
import Pager from "@/Pages/Admin/Modules/Common/Controllers/Pager";
import Spinner from "@/Pages/Admin/Modules/Common/Controllers/Spinner";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";

import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";

import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { hotelService } from "@/Pages/Admin/Modules/Hotel/Services/HotelService";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";

@WithRender
@Component({
  components: {
    Pager,
    Spinner,
    "validation-error": ValidationError,
  },
})
export default class HoltelList extends Vue {
  protected Title: string = "";
  protected Phone: string = "";
  protected Address: string = "";
  protected Property: any = {} ;
  protected HotelLists: any = {};
  protected ButtonStatus: boolean = false;
  protected paging: any = {};

  protected IsLoading: boolean = false;
  protected PostLoading: boolean = false;
  protected ui: any = {};
  protected errors: any = {};
  protected errorsModal: any = {};
  protected errorsHotel: any = {};
  protected isError: boolean = false;

  protected RequestTitle: string = "";
  protected RequestAddress: string = "";
  protected RequestCity: any = "";
  protected TourOperatorList: any = [];
  protected CityList: any = [];
  protected PropertyType: any = [];
  protected RequestOperator: any = "";

  constructor() {
    super();
    this.paging.current_page = 1;
    this.paging.last_page = 0;
    this.paging.per_page = 0;
  }

  public hideModal() {
    this.Title = "";
  }

  public beforeMount() {
    this.GetAllCityList();
    // this.GetAllTourOperatorList();
  }
  get permission() {
    return common.permissionCheck;
  }

  public mounted() {
    this.CallHotelsList();
    this.getAllPropertyType();
  }
  protected async getAllPropertyType() {
    this.ui.IsLoading = true;
    trekService
      .getPropertyType()
      .then((res: any) => {
        res.data.data.filter((propertype: any) => {
          propertype.IsActive = false;
          // console.log(this.Pricing.List);
        });
        this.PropertyType = res.data.data;
        // console.log(this.DestinationData);
      })
      .catch((error: any) => {
        this.errors = error;
      })
      .finally(() => {
        this.ui.IsLoading = false;
      });
  }

  protected CallHotelsList() {
    this.errorsHotel = {};
    this.HotelLists = {};
    this.IsLoading = true;
    let data = {
      paging: {
        current_page: this.paging.current_page,
        last_page: this.paging.last_page,
        per_page: this.paging.per_page,
      },
      search: {
        title: this.RequestTitle,
        address: this.RequestAddress,
        tour_operator: this.RequestOperator ? this.RequestOperator.id : "",
        city: this.RequestCity ? this.RequestCity.id : "",
      },
      sorting: {
        sort_by: "id",
        sort_order: "desc",
      },
    };
    trekService
      .searchHotelByFilter(data)
      .then((res: any) => {
        this.HotelLists = res.data.data.data;
        this.paging.last_page = res.data.data.last_page;
        this.paging.per_page = res.data.data.per_page;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsHotel).then((res) => {
          this.errorsHotel = res;
        });
      })
      .finally(() => {
        this.IsLoading = false;
      });
  }

  // clear all Filter
  public clearAllFilter() {
    this.RequestTitle = "";
    this.RequestAddress = "";
    this.RequestCity = "";
    this.CallHotelsList();
  }

  public GetAllCityList() {
    this.ui.IsLoading = true;
    hotelService
      .getCityList()
      .then((res: any) => {
        this.CityList = res.data.data;
        // console.log(res.data.data);
      })
      .catch((error: any) => {
        this.errors = error;
      })
      .finally(() => {
        this.ui.IsLoading = false;
      });
  }

  // public GetAllTourOperatorList() {
  //   this.ui.IsLoading = true;
  //   trekService
  //     .getTourOperatorList()
  //     .then((res: any) => {
  //       this.TourOperatorList = res.data.data;
  //       // console.log(res.data.data);
  //     })
  //     .catch((error: any) => {
  //       this.errors = error;
  //     })
  //     .finally(() => {
  //       this.ui.IsLoading = false;
  //     });
  // }

  protected hotelModal() {
    if (this.permission.hotel_add) {
      $("#createHotel").modal("show");
      this.Title = "";
      this.Phone = "";
      this.Address = "";
      this.Property = {};

    }
  }

  protected hideModalSegment() {
    $("#createHotel").modal("hide");
    $(".modal-backdrop").remove();
    this.Title = "";
    this.Phone = "";
    this.Address = "";
    this.Property = "";
    this.isError = false;
  }

  protected CreateHotel() {
    this.errors = {};
    this.errorsModal = {};
    this.isError = false;
    if (!this.IsValidationTrue()) {
      return;
    }
    this.ButtonStatus = true;
    this.PostLoading = true;
    const data = {
      title: this.Title,
      phone: this.Phone,
      address: this.Address,
      property_type_id : this.Property.id
    };
    // console.log(data);
    trekService
      .AddHotel(data)
      // Trek.AddTrek(data)
      .then((res: any) => {
        // console.log("add Trek controller", res.data.data.id);
        // console.log("from Vue", res.data.data);
        this.hideModal();
        this.$router.push({
          name: "create-business-hotel-generaltab",
          query: {
            id: res.data.data.id,
          },
        });
        flashService.Success(
          "Hotel Created",
          "A new Hotel Created Successfully"
        );
        this.hideModalSegment();
      })
      .catch((error: any) => {
        console.log("Error Check", error);
        //   console.log("Error Check Inside");
        // common.sdCatchErr(error, this.errorsModal);
        common.sdCatchErr(error, this.errorsModal).then((res) => {
          this.errorsModal = res;
        });
      })
      .finally(() => {
        this.ButtonStatus = false;
        this.PostLoading = false;
      });
  }

  protected CancelHotel() {
    this.hideModal();
  }

  protected IsValidationTrue() {
    if (!this.Title) {
      Object.assign(this.errors, { title: ["The title field is required."] });
    }
    if (!this.Phone) {
      Object.assign(this.errors, {
        phone: ["The phone field is required."],
      });
    }
       if (!this.Property.id) {
         Object.assign(this.errors, {
           property_type_id: ["The property type field is required."],
         });
       }
    if (!this.Address) {
      Object.assign(this.errors, {
        address: ["The address field is required."],
      });
    }
    if (common.notEmpty(this.errors)) {
      this.isError = true;
      return false;
    } else {
      return true;
    }
  }

  protected toggleFilter() {
    $(".filter-body").slideToggle("medium");
    $(".filter-head").toggleClass("up");
  }

  public deleteModal() {
    $("#delete").modal("show");
  }

  public hidedeleteModal() {
    $("#delete").modal("hide");
    $(".modal-backdrop").remove();
    this.errors = {};
    this.isError = false;
  }

  public onPaging(CurrentPage: number) {
    // alert(CurrentPage);
    this.paging.current_page = CurrentPage;
    // this.PackageLists = {};
    this.CallHotelsList();
  }

  // Edit Tab for the selected Package
  public ViewPackage(Id: any) {
    alert("Package view function in future !!!");
    //   console.log('Package view function in future of id: ', Id);
  }

  // // Edit Tab for the selected Package
  public EditHotel(Id: any) {
    this.$router.push({
      name: "create-business-hotel-general",
      query: {
        id: Id,
      },
    });
  }


  public roomManagement(Id: any) {
    // alert();
    this.$router.push({
      name: "create-business-hotel-room",
      query: {
        id: Id,
      },
    });
  }

  public deletePackage() {
    this.hidedeleteModal();
    alert("Package delete function in future !!!");
  }

  public canceldeletePackage() {
    this.hidedeleteModal();
    // alert('Cancel !!!');
  }
}
